import axios from "axios";
import TeamsService from "../../services/TeamsService";

const novaClient = axios.create({
  baseURL:
    import.meta.env.VITE_NOVA_API_URL ??
    "https://oc-nova-dev-api-eza2cqbgftbxgycq.westus2-01.azurewebsites.net/api/v1",
  headers: { "Content-Type": "application/json" },
  // Fail slow/cold requests instead of hanging forever (which traps the app on
  // its loading spinner, e.g. when the API cold-starts after idle).
  timeout: 30000,
});

// Shared in-flight auth call so a burst of concurrent requests (e.g. loading a
// page after the tab sat idle) triggers at most one silent token refresh, which
// avoids racing Azure's rotating refresh tokens.
let authInFlight: Promise<string> | null = null;

novaClient.interceptors.request.use(async (config) => {
  // Resolve a *fresh* token: authenticate() returns the cached token when still
  // valid and silently refreshes an expired one, so a page left idle past the
  // access-token lifetime no longer fails with 401 ("Failed to load ...").
  let token = sessionStorage.getItem("teams_token");
  try {
    if (!authInFlight) {
      authInFlight = TeamsService.getInstance()
        .authenticate()
        .finally(() => {
          authInFlight = null;
        });
    }
    token = await authInFlight;
  } catch {
    // Refresh unavailable (e.g. service not initialized) — fall back to the
    // stored token; the response layer surfaces any auth error.
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default novaClient;
